import { BdaService, ServiceCategory } from "../models/BdaService";
import { PagedResults } from "../models/generics";
import client from "./axios";

const servicesUrl = `${window.__env.GATEWAY_URL}/v1/services`;

export const Services = {
  getServices: (params?: URLSearchParams) => client.get<PagedResults<BdaService> | Array<BdaService>>(servicesUrl, { params }),
  getService: (id: number, params?: URLSearchParams) => client.get<BdaService>(`${servicesUrl}/${id}`, { params }),
  createService: (service: BdaService, params?: URLSearchParams) => client.post<BdaService>(servicesUrl, service, { params }),
  getServiceMarkDown: (id: number) => client.get<string>(`${servicesUrl}/${id}/markdown`),
  updateService: (service: BdaService, params?: URLSearchParams) => client.put<BdaService>(`${servicesUrl}/${service.id}`, service, { params }),
  updateServiceFields: (service: BdaService, params?: URLSearchParams) => client.patch<BdaService>(`${servicesUrl}/${service.id}`, service, { params }),
  deleteService: (id: number, params?: URLSearchParams) => client.delete(`${servicesUrl}/${id}`, { params }),
  getModes: (params?: URLSearchParams) => client.get<string[]>(`${servicesUrl}/modes`, { params }),
  getAreas: (params?: URLSearchParams) => client.get<string[]>(`${servicesUrl}/areas`, { params }),
  getCategories: (params?: URLSearchParams) => client.get<PagedResults<ServiceCategory | Array<ServiceCategory>>>(`${servicesUrl}/categories`, { params }),
  createCategory: (body: ServiceCategory) => client.post(`${servicesUrl}/categories`, body),
  updateCategory: (id: number, body: ServiceCategory) => client.put(`${servicesUrl}/categories/${id}`, body),
  deleteCategory: (id: number) => client.delete(`${servicesUrl}/categories/${id}`),
}